import type { Faq } from '../types/content';

export const painPoints = ['Abrís la heladera y no sabés qué hacer con lo que tenés.', 'Comprás ingredientes que después terminan olvidados o sin usar.', 'Cocinás desde cero prácticamente todos los días.', 'Llegás cansado/a y terminás improvisando cualquier cosa.', 'Tenés un freezer lleno, pero no sabés exactamente qué hay ni qué usar primero.'];

export const faqs: Faq[] = [{
  question: '¿Es un recetario?',
  answer: 'No. Es un sistema para planificar, preparar y organizar tus comidas.'
}, {
  question: '¿Necesito tener un freezer grande?',
  answer: 'No. El sistema también contempla la organización y el aprovechamiento del espacio disponible.'
}, {
  question: '¿Sirve si vivo solo/a?',
  answer: 'Sí. Podés adaptar las cantidades, porciones y planificación a tu realidad.'
}, {
  question: '¿Sirve para una familia?',
  answer: 'Sí. Las herramientas permiten ajustar la planificación según la cantidad de personas.'
}, {
  question: '¿Dónde recibo el material?',
  answer: 'Recibís el acceso por correo electrónico, en formato PDF.'
}];

export const costs = ['Seguir preguntándote qué cocinar cada día', 'Comprar alimentos sin tener claro cómo vas a utilizarlos', 'Cocinar desde cero incluso cuando no tenés tiempo', 'Dejar preparaciones olvidadas en el freezer', 'Llegar cansado/a y tener que resolver la cena nuevamente'];

export const purchases = [['Andrea V.', 'Buenos Aires'], ['Carolina M.', 'Córdoba'], ['Julieta T.', 'Rosario'], ['Laura P.', 'Córdoba'], ['Mariana G.', 'Rosario'], ['Valeria R.', 'Mendoza']];
